import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { PlainCard } from './components'
// import TicketList from "./list";
import CreateTicket from './createForm'
import ErrorFallBack from '@/layout/Error'

const Ticket = () => {
  return (
    <PlainCard>
      <Routes>
        <Route
          path="/"
          errorElement={<ErrorFallBack />}
          // element={<TicketList onAdd={create} />}
          element={<Navigate to="/console/workbench?assistant=wechat" />}
        />
        <Route
          path="create"
          errorElement={<ErrorFallBack />}
          // element={<CreateTicket />}
          element={<Navigate to="/console/workbench?assistant=wechat" />}
        />
      </Routes>
    </PlainCard>
  )
}

Ticket.CreateTicket = CreateTicket

export default Ticket
